import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber'
import { useIntl } from 'react-intl'
import { ButtonLink } from '../../../../components/wrappers/Button'
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'

interface MenuComboBetCodesProps {
  pathname: string
  nested?: string
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
}

export const MenuComboBetCodes = ({
  pathname,
  nested,
  toggleDrawerOnMobile,
}: MenuComboBetCodesProps) => {
  const { formatMessage } = useIntl()

  return (
    <div onClick={toggleDrawerOnMobile}>
      <MenuItem
        className={nested}
        component={ButtonLink}
        href="/sportsbook/combo-bet-codes"
        selected={pathname.startsWith('/sportsbook/combo-bet-codes')}
      >
        <ListItemIcon>
          <ConfirmationNumberIcon />
        </ListItemIcon>
        <ListItemText primary={formatMessage({ id: 'sportsbook.sidebar.comboBetCodes' })} />
      </MenuItem>
    </div>
  )
}
